import React from 'react'
import { useDetectionExplorerStore } from '../DetectionExplorerStore'
import { DETECTION_EXPLORER_PAGE_SIZE } from '../config'
import { PaginationUI } from './PaginationUI'

type Props = {
    total: number
    // In filtered (accumulating) mode the total is unknown, so pagination is prev/next only and Next
    // is driven by `hasMore` rather than a computed last page.
    filtering: boolean
    hasMore: boolean
}

export const PaginationContainer: React.FC<Props> = ({ total, filtering, hasMore }) => {
    const page = useDetectionExplorerStore((s) => s.filters.page)
    const changeFilter = useDetectionExplorerStore((s) => s.changeFilter)

    const totalPages = Math.ceil(total / DETECTION_EXPLORER_PAGE_SIZE) || 1

    return (
        <PaginationUI
            page={page}
            totalPages={totalPages}
            filtering={filtering}
            hasMore={hasMore}
            onChange={(next) => changeFilter('page', next)}
        />
    )
}
